export const FETCH_USERS_LIST_REQUEST = 'FETCH_USERS_LIST_REQUEST';
export const FETCH_USERS_LIST_SUCCESS = 'FETCH_USERS_LIST_SUCCESS';
export const FETCH_USERS_LIST_ERROR = ' FETCH_USERS_LIST_ERROR';

export const FETCH_OPERATORS_LIST_REQUEST = 'FETCH_OPERATORS_LIST_REQUEST';
export const FETCH_OPERATORS_LIST_SUCCESS = 'FETCH_OPERATORS_LIST_SUCCESS';
export const FETCH_OPERATORS_LIST_ERROR = ' FETCH_OPERATORS_LIST_ERROR';

export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR';

export const RESEND_USER_INVITE_REQUEST = 'RESEND_USER_INVITE_REQUEST';
export const RESEND_USER_INVITE_SUCCESS = 'RESEND_USER_INVITE_SUCCESS';
export const RESEND_USER_INVITE_ERROR = 'RESEND_USER_INVITE_ERROR';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const UPDATE_OPERATOR_REQUEST = 'UPDATE_OPERATOR_REQUEST';
export const UPDATE_OPERATOR_SUCCESS = 'UPDATE_OPERATOR_SUCCESS';
export const UPDATE_OPERATOR_ERROR = 'UPDATE_OPERATOR_ERROR';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';

export const BULK_DELETE_OPERATORS_REQUEST = 'BULK_DELETE_OPERATORS_REQUEST';
export const BULK_DELETE_OPERATORS_SUCCESS = 'BULK_DELETE_OPERATORS_SUCCESS';
export const BULK_DELETE_OPERATORS_ERROR = 'BULK_DELETE_OPERATORS_ERROR';

export const FILTER_USER = 'FILTER_USER';
